export default __webpack_public_path__ + "static/media/es.968eafd1.svg";